import * as types from 'actions/actionTypes'

import initialState from './initialState'

export const clusterHead = (state = initialState.clusterHeads, action) => {
  let allClusterHeads = []
  let newClusterHeads = []
  switch (action.type) {
    case types.FETCH_CLUSTER_HEADS_SUCCESS:
      return { ...state, allClusterHeads: action.payload }
    case types.CREATE_CLUSTER_HEADS_SUCCESS:
      allClusterHeads = state.allClusterHeads
      allClusterHeads.forEach((value) => {
        let destroyed = action.payload.find((data) => data.id === value.id && data.destroyed)
        if (!destroyed) newClusterHeads.push(value)
      })
      action.payload.forEach((value) => {
        let destroyed = allClusterHeads.find((data) => data.id === value.id && value.destroyed)
        if (!destroyed) newClusterHeads.push(value)
      })
      return { ...state, allClusterHeads: newClusterHeads }
    default:
      return state
  }
}
